import { Config } from '@adornis/config/config.js';

export const matchingConfig = new Config('matching', {
  DIRECT_MAIL_COPY_ADDRESS: {
    env: true,
    required: false,
    client: true,
    name: 'DIRECT_MAIL_COPY_ADDRESS',
    parse: (val: string | null | undefined) => {
      return val || null;
    },
    defaultVal: null,
  },
});
